import React from 'react';
import { Box, Button, Typography, Link, useTheme, useMediaQuery } from '@mui/material';
import { useCognito } from '../hooks/useCognito';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Login() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { user, loading, isAuthenticated, login } = useCognito();
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    if (isAuthenticated && user) {
      // Redirect automatico se già autenticato
      // Se c'è una pagina di destinazione salvata, vai lì, altrimenti vai alla home
      const from = location.state?.from?.pathname || '/';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, user, navigate, location]);

  // Controlla se l'utente è stato reindirizzato da una pagina protetta
  const isRedirectedFromProtectedRoute = location.state?.from;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f3f3f3',
        px: 2,
      }}
    >
      {/* Sinistra: logo e titolo */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-end' },
          justifyContent: 'center',
          pr: { md: 6 },
          mb: { xs: 4, md: 0 },
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: '#000000',
            fontWeight: 700,
            mb: 3,
            fontFamily: 'Exo 2, sans-serif',
            textAlign: { xs: 'center', md: 'right' },
            fontSize: { xs: '1.5rem', sm: '1.5rem', md: '2rem' },
          }}
        >
          RUNtime App for RUN
        </Typography>
        <Box
          component="img"
          src="/jira-logo-scaled.png"
          alt="Logo"
          sx={{
            width: { xs: 150, sm: 220, md: 300 },
            height: 'auto',
            display: 'block',
          }}
        />
      </Box>
      {/* Destra: login */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' },
          justifyContent: 'center',
          pl: { md: 6 },
          width: '100%',
        }}
      >
                 {loading ? (
                       <Typography sx={{ mb: 2 }}>Loading authentication...</Typography>
          ) : isAuthenticated && user ? (
            <Typography sx={{ mb: 2, color: '#388e3c' }}>You are already authenticated as {user.email}</Typography>
         ) : (
           <>
             
             <Button
               variant="contained"
               onClick={login}
               sx={{
                 bgcolor: '#00b6b6',
                 color: 'white',
                 fontWeight: 700,
                 fontSize: 18,
                 borderRadius: 2,
                 px: 6,
                 py: 1.5,
                 mb: 2,
                 width: { xs: '100%', sm: 320 },
                 boxShadow: 'none',
                 '&:hover': { bgcolor: '#009e9e' },
                 textTransform: 'none',
               }}
             >
               Login
             </Button>
           </>
         )}
        
      </Box>
    </Box>
  );
} 